import { Link } from 'react-router-dom';

import './styles/NewspaperCategorySlider.css';

/**
 * Displays a single category as a fixed-size rectangle with the title centered.
 */
export default function NewspaperCategoryCard({ title, link }) {
  const content = (
    <div className="newspaper-category-card__container">
      <p className="newspaper-category-card__title">{title}</p>
    </div>
  );

  // Wrap the card in a Link if a destination is provided.
  return link ? (
    <Link to={link} className="no-underline">
      {content}
    </Link>
  ) : (
    content
  );
}